import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { TextField, AddressField, Step } from '../SteppedForm';

import rules from './rules';

const StepBank = (props) => {
  return (
    <Step
      id="bank"
      title="Payment Details"
      skip={(formdata) => formdata.onboardingFor === 'vehicle'}>
      <Typography variant="body1">
        This information is solely so we can deposit money into your account.
      </Typography>
      <Typography variant="body1" class="formQuestion">
        Operator Account payment details for {props.getAccountName()}{' '}
      </Typography>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField id="bank" label="Bank Name" required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField id="account" label="Account Name" required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="bsb"
            label="BSB"
            valid={rules.numeric_stripped_fixed(6)}
            modify={(value) => props.limitLength(value, 6)}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="accountnum"
            label="Account #"
            valid={rules.accountNumber(9)}
            modify={(value) => props.limitLength(value, 9)}
            required
          />
        </Grid>
        {props.state?.formdata?.spotto ? (
          <Grid item xs={12}>
            <AddressField
              id="bankaddress"
              label="Bank Branch Address"
              country="AU"
              fetchDetails
              required
            />
          </Grid>
        ) : (
          ''
        )}
      </Grid>
    </Step>
  );
};

export default StepBank;
